import analytics from './analytics'
import applications from './applications'
import campaigns from './campaigns'
import chats from './chats'
import documentBundles from './document_bundles'
import eligibilities from './eligibilities'
import feedbackRequests from './feedback_requests'
import flags from './flags'
import opportunities from './opportunities'
import organization from './organization'
import payments from './payments'
import users from './users'

export default {
  namespaced: true,
  modules: {
    analytics,
    applications,
    campaigns,
    chats,
    documentBundles,
    eligibilities,
    feedbackRequests,
    flags,
    opportunities,
    organization,
    payments,
    users,
  },
}
